import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';
import { AngularFireModule } from 'angularfire2';
import { MatDialogModule } from '@angular/material/dialog';
import { Select2Module } from 'ng2-select2';

import { AppComponent } from './app.component';
import { DisclaimerComponent } from './home/disclaimer/disclaimer.component';
import { ForumComponent } from './forum/forum.component';
import { ForumDetailComponent } from './forum/forum-detail/forum-detail.component';
import { ForumDialogComponent } from './forum/forum-dialog/forum-dialog.component';
import { ForumFormComponent } from './forum/forum-form/forum-form.component';
import { ForumItemComponent } from './forum/forum-item/forum-item.component';
import { ForumListComponent } from './forum/forum-list/forum-list.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LoginFormComponent } from './login/login-form/login-form.component';
import { MessageDialog } from './users/user-pm/message-dialog/message-dialog.component';
import { MessageFormComponent } from './users/message-form/message-form.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NotificationItemComponent } from './activity/notification-item/notification-item.component';
import { NotificationListComponent } from './activity/notification-list/notification-list.component';
import { PasswordResetComponent } from './signup/password-reset/password-reset.component';
import { PrivateMessageComponent } from './users/user-pm/private-message/private-message.component';
import { ProfileComponent } from './profile/profile.component';
import { RepliesListComponent } from './replies/replies-list/replies-list.component';
import { ReplyFormComponent } from './replies/reply-form/reply-form.component';
import { ReplyItemComponent } from './replies/reply-item/reply-item.component';
import { SignupComponent } from './signup/signup.component';
import { SignupFormComponent } from './signup/signup-form/signup-form.component';
import { SubtopicListComponent } from './topics/subtopic-list/subtopic-list.component';
import { TopicComponent } from './topics/topic/topic.component';
import { TopicListComponent } from './topics/topic-list/topic-list.component';
import { UsersComponent } from './users/users.component';
import { UserListComponent } from './users/user-list/user-list.component';
import { UserPMComponent} from './users/user-pm/user-pm.component';
import { UserViewComponent } from './users/user-view/user-view.component';

import { EqualValidator } from './validator/equal.directive';
import { FormatDatePipe } from './pipes/date.component';
import { LinkifyPipe } from './pipes/linkify.component';


const routes : Routes = [
  { path: '', component: HomeComponent },
  { path: 'comunidad', component: UsersComponent },
  { path: 'temas/:id', component: TopicComponent},
  { path: 'discusion/:id', component: ForumDetailComponent},
  { path: 'signup', component: SignupComponent},
  { path: 'perfil', component: ProfileComponent },
  { path: 'perfil/mensajes', component: UserPMComponent},
  { path: 'perfil/mensajes/:id', component: UserPMComponent},
  { path: 'discusiones', component: ForumComponent},
  { path: 'login', component: LoginComponent},
  { path: ':id', component: UserViewComponent},
];

@NgModule({
  entryComponents: [
    DisclaimerComponent,
    ForumDialogComponent,
    MessageDialog,
    MessageFormComponent,
  ],
  declarations: [
    AppComponent,
    DisclaimerComponent,
    EqualValidator,
    FormatDatePipe,
    ForumComponent,
    ForumDetailComponent,
    ForumDialogComponent,
    ForumFormComponent,
    ForumItemComponent,
    ForumListComponent,
    HomeComponent,
    LinkifyPipe,
    LoginComponent,
    LoginFormComponent,
    MessageDialog,
    MessageFormComponent,
    NavbarComponent,
    NotificationItemComponent,
    NotificationListComponent,
    PasswordResetComponent,
    PrivateMessageComponent,
    ProfileComponent,
    RepliesListComponent,
    ReplyFormComponent,
    ReplyItemComponent,
    SignupComponent,
    SignupFormComponent,
    SubtopicListComponent,
    TopicComponent,
    TopicListComponent,
    UsersComponent,
    UserListComponent,
    UserPMComponent,
    UserViewComponent,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    MatDialogModule,
    RouterModule.forRoot(
      routes,
      { enableTracing: true } // <-- debugging purposes only
    ),
    Select2Module,
  ],
  providers: [Title],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/app.module.ts